<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import McBadge from '@/components/McBadge'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Notifikasi',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McBadge,
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      isNewSubmodule: 'identity/isNewSubmodule',
    }),
    title() {
      return this.$t('global.object.notification')
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
      <div class="float-end">
        <b-button
          v-if="
            hasAccess(['e2a-popup-notifikasi:read', 'e3a-email-notifikasi:read']) &&
            hasAccess(['e1a-web-perilakupengemudi:read', 'e1b-web-umum:read', 'e1c-web-dms:read'])
          "
          variant="outline-primary"
          size="sm"
          class="mc-ico position-relative"
          @click="$router.push({ name: 'Notification Setting' })"
        >
          <i class="icon-outline_settings"></i>
        </b-button>
        <McBadge
          v-if="isNewSubmodule(['e2a-popup-notifikasi', 'e3a-email-notifikasi'])"
          variant="danger"
          size="small"
          type="notif"
        />
      </div>
    </div>

    <div class="card mc-card mc-card-front">
      <div class="card-body mc-card">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template #title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ $t('global.object.notification') }}</span>
            </template>
            <b-row class="mc-card__list">
              <b-col
                v-if="
                  hasAccessAll([
                    'raw_alerts_driver:read',
                    'e1a-web-perilakupengemudi:read',
                    'alert_code:read',
                  ])
                "
                sm="12"
                md="6"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Perilaku Pengemudi' })"
                  class="d-block w-100 mc-card__list-item"
                >
                  <i class="mc-fa icon-outline_people"> </i>
                  <McBadge
                    v-if="isNewSubmodule('e1a-web-perilakupengemudi')"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  />
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('global.object.driverBehavior') }}</h4>
                    <p>{{ $t('notification.text.showNotification.driverBehavior') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col
                v-if="hasAccessAll(['raw_alerts_dms:read', 'alert_code:read', 'e1c-web-dms:read'])"
                sm="12"
                md="6"
              >
                <b-button
                  variant="outline-light"
                  class="d-block w-100 mc-card__list-item"
                  @click="$router.push({ name: 'Driver Monitoring System' })"
                >
                  <i class="mc-fa icon-outline_video"></i>
                  <McBadge
                    v-if="isNewSubmodule('e1c-web-dms')"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  />
                  <div class="mc-card__list-item-content">
                    <h4>DMS</h4>
                    <p>{{ $t('notification.text.showNotification.dms') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col
                v-if="
                  hasAccessAll(['raw_alerts_umum:read', 'alert_code:read', 'e1b-web-umum:read'])
                "
                sm="12"
                md="6"
              >
                <b-button
                  variant="outline-light"
                  class="d-block w-100 mc-card__list-item"
                  @click="$router.push({ name: 'General' })"
                >
                  <i class="mc-fa icon-outline_folder"></i>
                  <McBadge
                    v-if="isNewSubmodule('e1b-web-umum')"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  />
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('global.object.general') }}</h4>
                    <p>{{ $t('notification.text.showNotification.general') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col
                v-if="
                  hasAccessAll(['raw_alerts_adas:read', 'alert_code:read', 'e1g-web-adas:read'])
                "
                sm="12"
                md="6"
              >
                <b-button
                  variant="outline-light"
                  class="d-block w-100 mc-card__list-item"
                  @click="$router.push({ name: 'Advanced Driver Assistance System' })"
                >
                  <i class="mc-fa icon-outline_adas"></i>
                  <McBadge
                    v-if="isNewSubmodule('e1g-web-adas')"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  />
                  <div class="mc-card__list-item-content">
                    <h4>ADAS</h4>
                    <p>{{ $t('notification.text.showNotification.adas') }}</p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
